import { render } from "./ProcessDashboardsDrawerPanel.vue?vue&type=template&id=15ad8bc2&scoped=true"
import script from "./ProcessDashboardsDrawerPanel.vue?vue&type=script&lang=js"
export * from "./ProcessDashboardsDrawerPanel.vue?vue&type=script&lang=js"

import "./ProcessDashboardsDrawerPanel.vue?vue&type=style&index=0&id=15ad8bc2&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ad8bc2"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTabs,QTab,QTabPanels,QTabPanel,QExpansionItem,QList,QItem,QItemSection});
